import { Divider, Next, Typography } from '@shipengine/giger';
import { Trans, useTranslation } from '@packlink/translation-provider';
import { getDividerStyles } from './TemplateFooterStyles';
import { LanguageTabOptions } from '@BrandedEmails/BrandedEmailEdition';
interface TemplateFooterProps {
    selectedLanguage?: LanguageTabOptions;
}
export function TemplateFooter({ selectedLanguage }: TemplateFooterProps): JSX.Element {
    const { t } = useTranslation(undefined, { lng: selectedLanguage?.value });
    return (
        <>
            <Divider css={getDividerStyles} />
            <Typography component="p" variant="body1">
                <Trans
                    t={t}
                    i18nKey={'branded-emails.template.footer'}
                    components={[<Next.Link key="link" href="#" />]}
                />
            </Typography>
        </>
    );
}
